import { TacticsAndTechniquesWebComponent } from './component/TacticsAndTechniquesWebComponent';
import { WEB_COMPONENT_TACTICS_AND_TECHNIQUES } from '../../webcomponents.constants';

export { TacticsAndTechniquesWebComponent };

window.customElements.define(WEB_COMPONENT_TACTICS_AND_TECHNIQUES, TacticsAndTechniquesWebComponent);
